<template>
  <div class="container">
    <div class="inner-container">
      <p class="more-on-this-topic">Read more</p>
      <a class="more-on-this-link" :href="attributes.value.link">{{
        attributes.value.text
      }}</a>
    </div>
  </div>
</template>
<script>
export default {
  props: ['attributes'],
  mounted () {
    console.log(this.attributes)
  }
}
</script>
<style lang="scss" scoped>
.container {
  max-width: 700px;
  margin-left: auto !important;
  margin-right: auto !important;

  // background: #f5f5f5;
  background-color: #eff3f4;
  .inner-container {
    padding: 15px 12px;
    .more-on-this-topic {
      margin-bottom: 5px !important;
    }

    .more-on-this-link {
      text-decoration: none !important;
    }

    .more-on-this-topic {
      font-family: $font-CuratorBold !important;
      //color: #333;
      font-size: 14px;
      text-transform: uppercase;
    }
  }
}
</style>
